import { AuthState } from '../types';

/** Same id as backend: CPS team owner in Crossover (Central PS scope). */
export const CENTRAL_PS_TEAM_OWNER_MANAGER_ID = 2371741;

/**
 * Manager id used for Central PS leaderboard/AI filtering.
 * Allowlisted users (org moved off CPS rosters) use the CPS owner id so Team view matches CPS scope.
 */
export function getCentralPSFilterManagerId(auth: AuthState): number {
  if (!auth.teamMembership?.hasCentralPSAccess) {
    throw new Error('Central PS access required');
  }
  if (auth.teamMembership.centralPSAccessViaAllowlist) {
    return CENTRAL_PS_TEAM_OWNER_MANAGER_ID;
  }
  return auth.managerId ?? CENTRAL_PS_TEAM_OWNER_MANAGER_ID;
}
